import React, { useEffect, useState } from 'react'
import { useStore, useDispatch } from 'react-redux'
import { doApproveDomainRequest, doGetDomainRequestorsByDomain } from '../../redux/actions/domain'
import { toast } from '../CommonComponents/ToastComponent/toast'

import MyDomainList from './my-domin-list'
import DomainRequestors from './domain-requestors'
import DomainCreateModal from './modals/domain-create'
import DomainDetailModal from './modals/domain-detail'
import DomainInviteModal from './modals/domain-invite'
import LoaderComponent from '../CommonComponents/LoaderComponent'

const MyDomainComponent = ({ settingsDomainPath }) => {
  const store = useStore().getState()
  const dispatch = useDispatch()
  const {
    domain: { myDomains, domainRequestors, isLoading },
  } = store

  const domainColumns = [
    {
      label: 'Domain Name',
      value: 'domainName',
    },
    {
      label: 'Company Name',
      value: 'companyName',
    },
    {
      label: 'Address 1',
      value: 'address1',
    },
    {
      label: 'Address 2',
      value: 'address2',
    },
    {
      label: 'City',
      value: 'city',
    },
    {
      label: 'State',
      value: 'state',
    },
    {
      label: 'Zip',
      value: 'zip',
    },
    {
      label: 'Country',
      value: 'country',
    },
    {
      label: 'URL',
      value: 'url',
    },
    {
      label: 'Phone',
      value: 'phone',
    },
    {
      label: 'Industry',
      value: 'industry',
    },
    {
      label: 'Company Size',
      value: 'companySize',
    },
  ]

  const [selectedDomain, setSelectedDomain] = useState(myDomains ? myDomains[0] : null)
  const [domainRoles, setDomainRoles] = useState([])
  const [isEdit, setIsEdit] = useState(false)

  const [showCreateModal, setShowCreateModal] = useState(false)
  const [showDetailModal, setShowDetailModal] = useState(false)
  const [showInviteModal, setShowInviteModal] = useState(false)

  const roleOptions = [
    {
      label: 'User',
      value: 1,
    },
    {
      label: 'Moderator',
      value: 2,
    },
    {
      label: 'Admin',
      value: 3,
    },
  ]

  const handleSelectDomain = (domain) => {
    setSelectedDomain(domain)
  }

  const handleChangeDomainRole = (userRole, roleId) => {
    setDomainRoles({
      ...domainRoles,
      [userRole.id]: roleId,
    })
  }

  // approve or reject domain request
  const handleApproveDomainRequest = (userRole, type) => {
    let roleId = 5
    if (type === 'approve') {
      if (!domainRoles[userRole.id]) {
        toast.show({
          title: 'Warning',
          description: 'Please select user role!',
        })
        return
      }
      roleId = domainRoles[userRole.id]
    }

    dispatch(
      doApproveDomainRequest({
        userRoleId: userRole.id,
        roleId: roleId,
        type,
        userId: userRole?.userId
      })
    ).then(() => {
      setIsEdit(false)
      dispatch(
        doGetDomainRequestorsByDomain({
          domainId: selectedDomain.id
        })
      )
    })
  }

  const handleChangeIsEdit = () => {
    setIsEdit(!isEdit)
  }

  const handleShowCreateModal = () => {
    setShowCreateModal(true)
  }

  const handleCloseCreateModal = () => {
    setShowCreateModal(false)
  }

  const handleShowDetailModal = (domain) => {
    setSelectedDomain(domain)
    setShowDetailModal(true)
  }

  const handleCloseDetailModal = () => {
    setShowDetailModal(false)
  }

  const handleShowInviteModal = (domain) => {
    setSelectedDomain(domain)
    setShowInviteModal(true)
  }

  const handleCloseInviteModal = () => {
    setShowInviteModal(false)
  }

  useEffect(() => {
    if (!selectedDomain || !selectedDomain.id) {
      return
    }
    dispatch(
      doGetDomainRequestorsByDomain({
        domainId: selectedDomain.id
      })
    )
  }, [selectedDomain, dispatch])

  useEffect(() => {
    if (!myDomains || myDomains.length === 0) {
      return
    }
    if (!selectedDomain) {
      setSelectedDomain(myDomains[0])
      return
    }
    const selectedDomainIndex = myDomains.findIndex(myDomain => myDomain.userRoleId === selectedDomain.userRoleId)
    if (selectedDomainIndex === -1) {
      setSelectedDomain(myDomains[0])
      return
    }
    setSelectedDomain(myDomains[selectedDomainIndex])
    // eslint-disable-next-line
  }, [myDomains])

  useEffect(() => {
    if (!domainRequestors || domainRequestors.length === 0) {
      return
    }
    const tmpDomainRoles = {}
    domainRequestors.forEach(requestor => {
      tmpDomainRoles[requestor.id] = requestor.role?.id
    })
    setDomainRoles({ ...tmpDomainRoles })
  }, [domainRequestors])

  return (
    <div className={`mydomain-component ${isLoading ? 'loading' : ''}`}>
      {isLoading && <LoaderComponent />}
      <div>
        <MyDomainList
          myDomains={myDomains}
          selectedDomain={selectedDomain}
          onSelectDomain={handleSelectDomain}
          onShowCreateModal={handleShowCreateModal}
          onShowDetailModal={handleShowDetailModal}
          onShowInviteModal={handleShowInviteModal}
        />
      </div>
      {!settingsDomainPath && <div className=" domain-content d-flex flex-column flex-lg-row">
        <DomainRequestors
          domainRequestors={domainRequestors}
          selectedDomain={selectedDomain}
          onApproveDomainRequest={handleApproveDomainRequest}
          domainRoles={domainRoles}
          onChangeDomainRole={handleChangeDomainRole}
          isEdit={isEdit}
          onChangeIsEdit={handleChangeIsEdit}
          roleOptions={roleOptions}
        />
      </div>}
      <>
        <DomainCreateModal
          show={showCreateModal}
          onClose={handleCloseCreateModal}
        />
        <DomainDetailModal
          show={showDetailModal}
          onClose={handleCloseDetailModal}
          domainColumns={domainColumns}
          selectedDomain={selectedDomain}
          showEdit
        />
        <DomainInviteModal
          show={showInviteModal}
          onClose={handleCloseInviteModal}
          roleOptions={roleOptions}
          selectedDomain={selectedDomain}
        />
      </>
    </div>
  )
}

export default MyDomainComponent